let settingsLoaded = false;
let passwordHandlerAttached = false;

export function isSettingsLoaded() {
    return settingsLoaded;
}

export function setSettingsLoaded(value) {
    settingsLoaded = value;
}

export function resetSettingsState() {
    settingsLoaded = false;
    passwordHandlerAttached = false;
}

export function isPasswordHandlerAttached() {
    return passwordHandlerAttached;
}

export function setPasswordHandlerAttached(value) {
    passwordHandlerAttached = value;
}
